import { HomepageSliderTab } from './tabs/HomepageSliderTab'

export const HomepageSliderPage = () => {
  return (
    <div className="py-6">
      <div className="mb-8">
        <h1 className="text-[23px] font-bold text-foreground">Homepage Slider</h1>
        <p className="text-[14px] text-muted-foreground mt-1">Manage the storefront carousel — slide layout, content and scheduling</p>
      </div>
      <HomepageSliderTab />
    </div>
  )
}
